import React from 'react';
import { Stack } from '@mantine/core';
import LinkStyleToolbar, { linkStyleToCss } from '../../blocks/web/shared/LinkStyleToolbar';
import { usePuckRichTextStyle } from '../../context/PuckRichTextStyleContext';
import { usePuckSiteTheme, sitePrimaryColor } from '../PuckSiteThemeContext';

/**
 * Style par défaut des textes d'un bloc, par rôle (question, réponse…) :
 * police, taille, gras / italique / souligné, couleur — les réglages des
 * liens d'en-tête. Vide : le texte suit la police du site. Ce qu'on force
 * dans le texte lui-même (barre d'outils) reste prioritaire.
 *
 * `defaultColor` d'un rôle : la couleur que le canvas rend sans réglage
 * (`'primary'` : la couleur principale du site), pour que le champ ne montre pas du noir.
 *
 * @param {{ key: string, label: string, defaultColor?: string }[]} roles
 */
function TextRolesField({ roles, value, onChange }) {
  const { fontFamilies } = usePuckRichTextStyle();
  const fontOptions = [{ label: 'Par défaut', value: '' }, ...fontFamilies];
  const styles = value || {};
  const siteTheme = usePuckSiteTheme();
  const renderedColor = (role) => (role.defaultColor === 'primary' ? sitePrimaryColor(siteTheme) : role.defaultColor);

  return (
    <Stack gap="sm">
      {roles.map((role) => (
        <LinkStyleToolbar
          key={role.key}
          label={role.label}
          fontLabel={`Police : ${role.label}`}
          fontOptions={fontOptions}
          value={styles[role.key]}
          colorValue={styles[role.key]?.color || renderedColor(role)}
          onChange={(next) => onChange({ ...styles, [role.key]: next })}
        />
      ))}
    </Stack>
  );
}

export const puckTextRolesField = (roles) => ({
  type: 'custom',
  label: 'Style des textes',
  render: ({ value, onChange }) => <TextRolesField roles={roles} value={value} onChange={onChange} />,
});

/** CSS d'un rôle de texte, sans clé vide : il se pose sur le style du bloc. */
export const textRoleCss = (textStyles, role) => Object.fromEntries(
  Object.entries(linkStyleToCss(textStyles?.[role])).filter(([, css]) => css !== undefined),
);
